import React, { useEffect, useState } from "react"
import { FaGithub, FaJava } from "react-icons/fa"
import { IoMdClose, IoMdMailUnread } from "react-icons/io"
import { IoLogoJavascript } from "react-icons/io5"
import { RxExternalLink } from "react-icons/rx"
import { Spotlight } from "./components/ui/spotlight.tsx"
// import { FlipWords } from './components/ui/flip-words.tsx';
import { HoverBorderGradient } from "./components/ui/hover-border-gradient.tsx"
import { HoverEffect } from "./components/ui/card-hover-effect.tsx"
import { SiTypescript } from "react-icons/si"
import { FloatingNav } from "./components/ui/floating-navbar.tsx"
import { ImagesSlider } from "./components/ui/image-slider.tsx"
import { BackgroundBeams } from "./components/ui/background-beams.tsx"

const Home = () => {
    const [show, setShow] = useState(false)

    const toggleProfile = () => {
        setShow(!show)
        console.log(show)
    }

    useEffect(() => {
        document.body.style.overflowY = show ? "hidden" : "auto"
    }, [show])

    const projects = [
        {
            title: "Billy",
            description:
                "Work in Progress - An AI-powered bill splitting platform that automatically extracts structured receipt data using PaddleOCR and LLMs, eliminating manual item entry. Built with an asynchronous processing pipeline for OCR and intelligent bill parsing, enabling scalable expense management and seamless room-based bill sharing.",
            link: "https://billy-pied.vercel.app/",
            techstack: "Next.js, FastAPI, PostgreSQL, OCR, LLMs, RabbitMQ, Celery, AWS S3, Docker",
            bg: "cyanRed",
            live: true,
        },
        {
            title: "Estai",
            description:
                "Work in Progress — An AI-powered voice customer support platform that enables natural, real-time conversations between users and intelligent agents. Trying to build with a low-latency voice pipeline integrating speech input, LLM-powered responses, and audio streaming to deliver responsive and context-aware customer interactions.",
            link: "https://github.com/KoushikMCN/backend-estai",
            techstack: "Next.js, FastAPI, WebRTC, Python, Gemini API, LLMs, Text-to-Speech, Speech-to-Text",
            bg: "bluePurple",
        },
        {
            title: "KubeOps",
            description:
                "Work in Progress — An agentic Kubernetes operations platform that automates infrastructure diagnosis through AI-powered diagnostic workflows. Leveraging LangGraph and specialized Kubernetes tools, KubeOps investigates deployment failures, analyzes cluster resources, and orchestrates contextual troubleshooting to identify the root cause of infrastructure issues.",
            link: "https://github.com/KoushikMCN/kubeops-backend",
            techstack: "Python, FastAPI, LangGraph, LLMs, Kubernetes, Docker, Prometheus, Grafana, ELK Stack",
            bg: "blueGreen",
        },
        {
            title: "e-SRL",
            description:
                "An AI-driven educational platform that transforms static study materials into interactive learning experiences. Leveraging RAG, and LLMs, e-SRL provides intelligent question answering, generates AI-powered video explanations, and creates relevant games using Google ADK through multi-agent workflows for level design, code generation, and validation.",
            link: "https://github.com/Somnathumapathi/esrl_basic",
            techstack: "Python, FastAPI, Streamlit, Gemini API, Chroma Vector Database, FFmpeg, RAG, AI/ML",
            bg: "bluePurple",
        },
        {
            title: "TrashTrace",
            description:
                "A QR-based gamified waste disposal application designed to encourage responsible waste management. The system integrates smart IoT-enabled bins, achieving nearly 90% accuracy in waste segregation.",
            link: "https://github.com/synapsecode/SIH24",
            techstack: "Flutter, Flask, Jinja2, Python, Arduino, ESP8266, ESP32, IoT, AI/ML",
            bg: "blueGreen",
        },
        {
            title: "KolamVerse",
            description:
                "An AI-powered creative platform for generating and animating traditional Kolams. Built using FastAPI and the Gemini API for computer vision, it supports text-to-pattern generation, customizable Kolam creation, and interactive drawing practice — blending cultural art with modern AI-driven creativity.",
            link: "https://github.com/synapsecode/KolamVerse/",
            techstack: "FastAPI, HTML, CSS, Gemini API, Computer Vision, AI",
            bg: "kolamVerse",
        },
        {
            title: "ETH ChitFund",
            description:
                "Ethereum-driven chit funds offer decentralized operations for participant enrollment, bid management, and payout distribution. This solution leverages blockchain technology to ensure transparency and security in managing chit fund activities.",
            link: "https://github.com/synapsecode/chETHFunds/",
            techstack: "NextJS, Solidity, Firebase, TailwindCSS",
        },
        {
            title: "Credentus",
            description:
                "A decentralized credentialing system allows companies to issue secure credentials to individuals using blockchain technology, ensuring transparency and reducing fraud risks. This system enhances verification processes and enables seamless sharing of verified credentials across platforms.",
            link: "https://github.com/dawksh/aventus-creds/tree/koushik/",
            techstack: "NextJS, Solidity, Supabase, TailwindCSS",
        },
    ]

    const experience = [
        {
            title: "Technical Intern",
            techstack: "Rakuten India\nBengaluru, KA\nFeb 2026 - Aug 2026",
            location: "Bengaluru, KA",
            bg: "rakuten",
            description:
                "Developing cloud-native solutions on GCP by building Kubernetes operational dashboards, deployment automation tools, and observability platforms. Designed Logstash pipelines and ELK dashboards to visualize custom Prometheus metrics across distributed services, while implementing automated monitoring and alerting workflows to improve deployment reliability and production visibility.",
        },
        {
            title: "Frontend Developer (freelance)",
            techstack: "Refresh\nMar 2025 - May 2025",
            location: "Remote",
            bg: "cyanRed",
            description:
                "Developed and shipped seven production-ready pages for a gaming tournament organizing platform using Next.js and Redux for state management. Focused on crafting immersive, high-performance UIs that blended luxury and gaming aesthetics to enhance user engagement and visual appeal. Collaborated closely with the client to deliver a polished, responsive, and modern front-end experience.",
        },
        {
            title: "Full Stack Developer",
            techstack: "Win Research Center (SelfyPage)\nBengaluru, KA\nMay 2025 - Oct 2025",
            location: "Bengaluru, KA",
            description:
                "Engineered a modular full-stack web application with a React and Next.js frontend consuming RESTful APIs built in Go (Gin). Optimized UI rendering for better performance and responsiveness. Integrated AWS and Firebase for CI/CD, authentication, and cloud hosting, improving deployment speed, reliability, and iteration cycles in an agile environment.",
        },
        {
            title: "Full Stack Developer (Internship)",
            techstack: "Win Research Center (FitChoice World)\nremote\nNov 2024 - Apr 2025",
            location: "Remote",
            description:
                "Spearheaded backend development of booking and user-matching systems, ensuring real-time scheduling and consistent user experience. Collaborated with product, design, and analytics teams to translate business needs into 10+ production-ready features, accelerating time-to-market. Architected a cross-platform solution with an admin/vendor web portal, mobile app, and Express.js backend powered by PostgreSQL and Prisma ORM.",
        },
        {
            title: "Full Stack Developer (Internship)",
            techstack: "BurdenOff\nremote\nNov 2024 - Dec 2024",
            location: "Remote",
            description:
                "Implemented cross-platform features using Capacitor.js, Node.js, Prisma, and GraphQL APIs, leveraging AWS S3 and Azure Blob Storage for scalable cloud data handling. Built an automated online testing platform with Flask, integrating webhooks to process live camera feeds on Azure, reducing manual review effort by approximately 40%.",
        },
    ]

    const navItems = [
        {
            name: "About Me",
            link: "#about",
        },
        {
            name: "Works",
            link: "#work",
        },
        {
            name: "Skills",
            link: "#skills",
        },
        {
            name: "MEE",
            link: "#MEE",
        },
    ]

    return (
        <div>
            <div className="App p-8 sm:p-8 sm:pl-16 text-white max-w-screen min-h-screen bg-black h-auto font-page">
                {!show && <Spotlight className="text-xl -mt-4 sm:mt-0" fill={"blue"} />}
                <header className="mt-14 sm:mt-8 sm:pr-14 md:-mt-4">
                    <nav className=" w-2/3 m-auto">
                        <ul className="hidden xl:flex justify-around text-xl px-24 my-10">
                            <li className="hover:scale-110 transition duration-300 ">
                                <a href="#about">About Me</a>
                            </li>
                            <li className="hover:scale-110 transition duration-300 ">
                                <a href="#work">Works</a>
                            </li>
                            <li className="hover:scale-110 transition duration-300 ">
                                <a href="#skills">Skills</a>
                            </li>
                        </ul>
                        <FloatingNav className="hidden lg:flex" navItems={navItems} />
                    </nav>
                    <img src="profile.JPG" alt="Profile" onClick={() => toggleProfile()} className="cursor-pointer size-24 sm:size-36 rounded-full" />
                    <div className="flex lg:justify-between flex-col lg:flex-row">
                        <div>
                            {/* <p className=''>Hi, I am</p> */}
                            <h1 className="text-5xl text-yellow-400 font-bold">Koushik M Bhagavath</h1>
                            <h2 className="text-xl text-slate-300">Software Developer</h2>
                        </div>
                        <div className="flex relative gap-x-2">
                            <HoverBorderGradient as={"a"} containerClassName={`border-0 ${show && "hidden"}`}>
                                <a href="https://github.com/KoushikMCN" target="_blank" rel="noreferrer" className="text-nowrap flex justify-center items-center">
                                    My GitHub&nbsp;
                                    <FaGithub className="text-cyan-400" />
                                </a>
                            </HoverBorderGradient>
                            <HoverBorderGradient as={"a"} clockwise={false} containerClassName={`border-0 ${show && "hidden"}`}>
                                <a
                                    href="https://mail.google.com/mail/?view=cm&fs=1&to=koushik.mbp@gmail.com"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="text-nowrap flex justify-center items-center"
                                >
                                    Work with me&nbsp;
                                    <IoMdMailUnread className="text-cyan-400" />
                                </a>
                            </HoverBorderGradient>
                        </div>
                    </div>
                    <a href="/resume" className="text-cyan-400 text-lg">
                        Resume
                        <RxExternalLink className="inline-block relative -top-0.5" />
                    </a>
                </header>
                <main className="sm:pr-14">
                    {/* <div className='text-3xl mt-20'>
                        I build<FlipWords words={words} duration={800} className='font-bold' />websites.
                    </div> */}
                    <section className="text-lg pt-36 pb-12" id="about">
                        <h2 className="text-4xl text-nowrap mb-2 text-cyan-400 font-bold">About Me</h2>
                        <p className="text-justify">
                            Currently building projects around <strong>Agentic AI, Voice AI</strong> and have built <strong>RAG based projects</strong> as well. I like to build cool stuff solving real and exciting problems.
                            I'm genuinely passionate about development, and I love building scalable, cloud-native systems, and integrating AI-powered solutions. <br />Over the years, I’ve worked across
                            the entire stack—from crafting responsive interfaces with <strong>Next.js, React.js, TypeScript, and TailwindCSS</strong> to building reliable backend
                            services using <strong>FastAPI, Express.js, Go (Gin), and Python</strong>. I’m curious about how systems work under the hood, which lead me to explore
                            areas beyond application development, including <strong>Docker, Kubernetes, Terraform, CI/CD, AWS, and GCP</strong>. 
                            <br />I’m particularly interested in applying AI to solve interesting problems. I enjoy building intelligent applications using{" "}
                            <strong>LLMs, RAG pipelines, vector databases, and computer vision</strong>, with a focus on creating practical, impactful solutions.
                            {/* {" "}When I’m not coding, I’m usually learning a new technology, experimenting with side projects, contributing to technical communities, or participating in hackathons.
                            I enjoy building things, solving challenging problems, and continuously pushing myself to become a better engineer. */}
                        </p>
                    </section>
                    <section className="text-lg pt-28" id="work">
                        <h2 className="text-4xl text-nowrap mb-2 text-cyan-400 font-bold">Experience</h2>
                        <HoverEffect items={experience} height={380} />
                    </section>
                    <BackgroundBeams className="h-[200%] mt-[300vh] md:mt-[180vh] lg:mt-[200vh] xl:mt-[100vh]" />
                    <section className="text-lg pt-12">
                        <h2 className="text-4xl text-nowrap mb-2 text-cyan-400 font-bold">My projects</h2>
                        <HoverEffect items={projects} height={360} />
                    </section>
                    {/* <BackgroundBeams className='lg:hidden h-[300vh] mt-[120vh]' /> */}
                    <section className="text-lg py-28" id="skills">
                        <h2 className="text-4xl mb-2 text-cyan-400 font-bold">Skills & Tools</h2>
                        <div className="flex flex-col gap-y-4">
                            <div>
                                <h3 className="text-xl text-yellow-400 font-bold">Languages</h3>
                                <div className="flex gap-5 flex-wrap">
                                    <IoLogoJavascript className="size-16 text-yellow-400 bg-slate-500/20 rounded-lg p-2" />
                                    <FaJava className="size-16 text-blue-400 bg-slate-500/20 rounded-lg p-2" />
                                    <SiTypescript className="size-16 text-blue-500 bg-slate-500/20 rounded-lg p-2" />
                                    <img
                                        src="https://imgs.search.brave.com/M-FiGkB1jPVADW6xtp-i7TJcdhipqz463z8s2cuR3WY/rs:fit:860:0:0/g:ce/aHR0cHM6Ly9hc3Nl/dHMuc3RpY2twbmcu/Y29tL2ltYWdlcy81/ODQ4MTUyZmNlZjEw/MTRjMGI1ZTQ5Njcu/cG5n"
                                        alt="Python"
                                        className="bg-slate-500/20 p-2 rounded-lg size-16"
                                    />
                                    <img
                                        src="https://imgs.search.brave.com/-aqoL7TbF81YYKKNWeBQt95KSjJ7exTkEElmLx4-xmk/rs:fit:860:0:0/g:ce/aHR0cHM6Ly9yYXcu/Z2l0aHVidXNlcmNv/bnRlbnQuY29tL2lz/b2NwcC9sb2dvcy9t/YXN0ZXIvY3BwX2xv/Z28ucG5n"
                                        alt="C++"
                                        className="bg-slate-500/20 p-2 rounded-lg size-16"
                                    />
                                    <img
                                        src="https://imgs.search.brave.com/rHu5ELNCeqIeCukLVQkhVTnsE5PsZGH09qHe6XWJ-xA/rs:fit:860:0:0/g:ce/aHR0cHM6Ly9zZWVr/bG9nby5jb20vaW1h/Z2VzL0MvYy1sYW5n/dWFnZS1sb2dvLUNF/MEY5MkU2ODMtc2Vl/a2xvZ28uY29tLnBu/Zw"
                                        alt="C"
                                        className="bg-slate-500/20 p-2 rounded-lg size-16"
                                    />
                                    <img src="https://binary.transparency.dev/images/logo_golang_hor.svg" alt="GoLang" className="bg-slate-500/20 p-2 rounded-lg size-16" />
                                </div>
                            </div>
                            <div>
                                <h3 className="text-xl text-yellow-400 font-bold">Frameworks/Libraries</h3>
                                <div className="flex gap-5 flex-wrap">
                                    <img src="react.webp" alt="ReactJS" className="bg-slate-500/20 p-2 rounded-lg size-16" />
                                    <img src="next.png" alt="NextJS" className="bg-slate-500/20 p-2 rounded-lg size-16" />
                                    <img src="jquery.png" alt="jQuery" className="bg-slate-500/20 p-2 rounded-lg size-16" />
                                    <img src="flask.png" alt="flask" className="bg-slate-500/20 p-2 rounded-lg size-16" />
                                    <img src="https://fastapi.tiangolo.com/img/icon-white.svg" alt="FastAPI" className="bg-slate-500/20 p-2 rounded-lg size-16" />
                                    <img src="https://miro.medium.com/v2/resize:fit:1400/0*kMJr4U_zX9g-Au-k.png" alt="Gin Gonic" className="bg-slate-500/20 p-2 rounded-lg h-16" />
                                </div>
                            </div>
                            <div>
                                <h3 className="text-xl text-yellow-400 font-bold">Technologies</h3>
                                <div className="flex gap-5 flex-wrap">
                                    <img src="tailwind.png" alt="TailwindCSS" className="bg-slate-500/20 p-2 rounded-lg size-16" />
                                    <img src="firebase.webp" alt="Firebase" className="bg-slate-500/20 p-2 rounded-lg size-16" />
                                    <img
                                        src="https://imgs.search.brave.com/bLKSpWf77eOn8Wy1IrD7usyP15scGGkETBunVAgX4Kc/rs:fit:860:0:0/g:ce/aHR0cHM6Ly9yYXcu/Z2l0aHVidXNlcmNv/bnRlbnQuY29tL2dp/dGh1Yi9leHBsb3Jl/L2Y0ZWM1MzQ3YTM2/ZTA2NTQwYTY5Mzc2/NzUzYTdjMzdhOGNi/NWExMzYvdG9waWNz/L3N1cGFiYXNlL3N1/cGFiYXNlLnBuZw"
                                        alt="Supabase"
                                        className="bg-slate-500/20 p-2 rounded-lg size-16"
                                    />
                                    <img
                                        src="https://logos-world.net/wp-content/uploads/2021/08/Amazon-Web-Services-AWS-Logo.png"
                                        alt="AWS"
                                        className="bg-slate-500/20 p-2 rounded-lg h-16"
                                    />
                                    <img src="https://img.icons8.com/color/512/google-cloud.png" alt="GCP" className="bg-slate-500/20 p-2 rounded-lg h-16" />
                                </div>
                            </div>
                            <div>
                                <h3 className="text-xl text-yellow-400 font-bold">Databases+Backend</h3>
                                <div className="flex gap-5 flex-wrap">
                                    <img src="firebase.webp" alt="Firebase" className="bg-slate-500/20 p-2 rounded-lg size-16" />
                                    <img
                                        src="https://imgs.search.brave.com/bLKSpWf77eOn8Wy1IrD7usyP15scGGkETBunVAgX4Kc/rs:fit:860:0:0/g:ce/aHR0cHM6Ly9yYXcu/Z2l0aHVidXNlcmNv/bnRlbnQuY29tL2dp/dGh1Yi9leHBsb3Jl/L2Y0ZWM1MzQ3YTM2/ZTA2NTQwYTY5Mzc2/NzUzYTdjMzdhOGNi/NWExMzYvdG9waWNz/L3N1cGFiYXNlL3N1/cGFiYXNlLnBuZw"
                                        alt="Supabase"
                                        className="bg-slate-500/20 p-2 rounded-lg size-16"
                                    />
                                    <img src="postgresql.webp" alt="PostgreSQL" className="bg-slate-500/20 p-2 rounded-lg size-16" />
                                    <img src="mongodb.png" alt="MongoDB" className="bg-slate-500/20 p-2 rounded-lg size-16" />
                                    <img
                                        src="https://imgs.search.brave.com/4Afaev-gC-2jBzkXD9NzF3q0ZXlqYmFVquG2mqUFSBs/rs:fit:860:0:0/g:ce/aHR0cHM6Ly91cGxv/YWQud2lraW1lZGlh/Lm9yZy93aWtpcGVk/aWEvY29tbW9ucy82/LzY0L0V4cHJlc3Nq/cy5wbmc"
                                        alt="ExpressJS"
                                        className="bg-slate-500/20 p-2 rounded-lg size-16"
                                    />
                                    <img
                                        src="https://imgs.search.brave.com/TTqzgX8Jg-WUy2fCjwmMySwIiwFsC_vv7N2G5ZnzUYI/rs:fit:860:0:0/g:ce/aHR0cHM6Ly9jZG4u/aWNvbnNjb3V0LmNv/bS9pY29uL2ZyZWUv/cG5nLTI1Ni9mcmVl/LW5vZGVqcy0yLTIy/NjAzNS5wbmc_Zj13/ZWJwJnc9MTI4"
                                        alt="NodeJS"
                                        className="bg-slate-500/20 p-2 rounded-lg size-16"
                                    />
                                    <img src="https://binary.transparency.dev/images/logo_golang_hor.svg" alt="GoLang" className="bg-slate-500/20 p-2 rounded-lg size-16" />
                                </div>
                            </div>
                            <div>
                                <h3 className="text-xl text-yellow-400 font-bold">DevOps & Observability</h3>
                                <div className="flex gap-5 flex-wrap">
                                    <img
                                        src="https://brandlogos.net/wp-content/uploads/2025/10/docker_mark-logo_brandlogos.net_yetav.png"
                                        alt="Docker"
                                        className="bg-slate-500/20 p-2 rounded-lg size-16"
                                    />
                                    <img
                                        src="https://juststickers.in/wp-content/uploads/2018/11/kubernetes-wordmark.png"
                                        alt="Kubernetes"
                                        className="bg-slate-500/20 p-2 rounded-lg size-16"
                                    />
                                    <img src="https://www.altnix.com/_next/static/media/jenkins1.d326e0b1.png" alt="Jenkins" className="bg-slate-500/20 p-2 rounded-lg size-16" />
                                    {/* <img
                                        src="https://cdn.shopaccino.com/igmguru/products/github-actions-course-5545043380044910m-59422727046295_l.webp?v=548"
                                        alt="GitHub Actions"
                                        className="bg-slate-500/20 p-2 rounded-lg h-16"
                                    /> */}
                                    <img
                                        src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSEDx6JNu2d76EMbKcGtJhYpdKzG72HctJXhMDozgbAkA&s=10"
                                        alt="Helm"
                                        className="bg-slate-500/20 p-2 rounded-lg size-16"
                                    />
                                    <img src="https://www.dijure.com/images/labs/prometheus_logo.png" alt="Prometheus" className="bg-slate-500/20 p-2 rounded-lg h-16" />
                                    <img
                                        src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a1/Grafana_logo.svg/3840px-Grafana_logo.svg.png"
                                        alt="Grafana"
                                        className="bg-slate-500/20 p-2 rounded-lg size-16"
                                    />
                                    <img
                                        src="https://miro.medium.com/v2/resize:fit:1400/1*vZDu4Bwj2GxQh8t1IjDq4w.png"
                                        alt="ELK Stack"
                                        className="bg-slate-500/20 p-2 rounded-lg h-16"
                                    />
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="text-lg pt-12" id="MEE">
                        <h2 className="text-4xl mb-2 text-cyan-400 font-bold">ME</h2>
                        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
                            <div className="md:w-3/5">
                                <p className="text-2xl text-yellow-400">More about me :p</p>
                                <ul className="list-disc p-4">
                                    <li>A passionate rider</li>
                                    <li>Average music enthusiast</li>
                                    <li>Like going on hikes</li>
                                    <li>Seafood and ice cream aficionado</li>
                                    <li>A beach person</li>
                                    <li>Fan of LH44</li>
                                </ul>
                                <div className="hidden my-10 md:flex justify-center items-center">
                                    <iframe
                                        title="Spotify"
                                        src="https://open.spotify.com/embed/playlist/37i9dQZF1EpunZEncdDzba?utm_source=generator&theme=1"
                                        width="100%"
                                        height="352"
                                        frameBorder="0"
                                        allowfullscreen=""
                                        allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                                        loading="lazy"
                                        className="w-full"
                                    ></iframe>
                                </div>
                            </div>
                            <ImagesSlider
                                images={[
                                    "./images/MEE (1).jpg",
                                    "./images/MEE (2).jpg",
                                    "./images/MEE (3).jpg",
                                    "./images/MEE (4).jpg",
                                    "./images/MEE (5).jpg",
                                    "./images/MEE (6).jpg",
                                ]}
                                direction="down"
                                className="size-[300px] md:size-[400px] rounded-lg text-slate-300/15"
                            >
                                Image Slider
                            </ImagesSlider>
                        </div>
                        <div className="flex my-10 md:hidden justify-center items-center">
                            <iframe
                                title="Spotify"
                                src="https://open.spotify.com/embed/playlist/37i9dQZF1EpunZEncdDzba?utm_source=generator&theme=1"
                                width="100%"
                                height="352"
                                frameBorder="0"
                                allowfullscreen=""
                                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                                loading="lazy"
                                className="w-full"
                            ></iframe>
                        </div>
                    </section>
                </main>
            </div>
            {show && (
                <div className="fixed top-0 flex h-full w-full justify-center backdrop-blur items-center bg-slate-800/90" onClick={() => toggleProfile()}>
                    <button className="absolute top-5 right-5 text-orange-600 text-2xl sm:text-5xl" onClick={() => toggleProfile()}>
                        <IoMdClose />
                    </button>
                    <img src="profile.JPG" alt="Profile" className="size-52 rounded-full" onClick={(e) => e.stopPropagation()} />
                </div>
            )}
        </div>
    )
}

export default Home
